(() => {
  'use strict';
  if (window.vinlightingPromotionReady) return;
  window.vinlightingPromotionReady = true;

  const copyStates = new WeakMap();
  let activeDialog = null;
  let opener = null;
  let consumeEscapeKeyup = false;

  function restoreButton(button, code, root) {
    button.querySelector('[data-promotion-code-label]').textContent = code;
    button.classList.remove('is-copied');
    button.setAttribute('aria-label', `${root.dataset.copyLabel} ${code}`);
  }

  async function copyCode(button) {
    const code = (button.dataset.promotionCode || '').trim();
    const root = button.closest('[data-promotion-root]');
    if (!code || !root) return;
    const state = copyStates.get(button) || {};
    if (state.pending) return;
    clearTimeout(state.timer);
    state.pending = true;
    copyStates.set(button, state);
    const status = root.querySelector('[data-promotion-status]');
    restoreButton(button, code, root);
    if (status) status.textContent = '';
    button.setAttribute('aria-busy', 'true');
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(code);
      if (!button.isConnected) return;
      button.querySelector('[data-promotion-code-label]').textContent = root.dataset.copySuccess;
      button.classList.add('is-copied');
      button.setAttribute('aria-label', `${code}: ${root.dataset.copySuccess}`);
      if (status) status.textContent = `${code}: ${root.dataset.copySuccess}`;
      state.timer = setTimeout(() => {
        if (button.isConnected) restoreButton(button, code, root);
        if (status && status.textContent === `${code}: ${root.dataset.copySuccess}`) status.textContent = '';
      }, 1600);
    } catch (_) {
      restoreButton(button, code, root);
      if (status) status.textContent = root.dataset.copyFailure;
      const selection = window.getSelection();
      if (selection) {
        const range = document.createRange();
        range.selectNodeContents(button.querySelector('[data-promotion-code-label]'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    } finally {
      state.pending = false;
      button.removeAttribute('aria-busy');
    }
  }

  function finishClose(dialog) {
    if (activeDialog !== dialog) return;
    document.documentElement.classList.remove('vl-promo-open');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (opener.isConnected) opener.focus({ preventScroll: true });
    }
    activeDialog = null;
    opener = null;
  }

  function closeDialog() {
    if (!activeDialog) return;
    const dialog = activeDialog;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    finishClose(dialog);
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const copyButton = event.target.closest('[data-promotion-copy]');
    if (copyButton) {
      event.preventDefault();
      copyCode(copyButton);
      return;
    }
    const trigger = event.target.closest('[data-promotion-open]');
    if (trigger) {
      const root = trigger.closest('[data-promotion-root]');
      const dialog = root && root.querySelector('.vl-promo__dialog');
      if (!dialog || dialog.id !== trigger.getAttribute('aria-controls')) return;
      event.preventDefault();
      closeDialog();
      activeDialog = dialog;
      opener = trigger;
      // Impulse quick view rewrites element IDs after fetching product blocks.
      const heading = dialog.querySelector('.vl-promo__heading');
      if (heading && heading.id) dialog.setAttribute('aria-labelledby', heading.id);
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      document.documentElement.classList.add('vl-promo-open');
      trigger.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-promotion-close]').focus({ preventScroll: true });
      return;
    }
    if (event.target.closest('[data-promotion-close]') || event.target === activeDialog) closeDialog();
  });

  document.addEventListener('keydown', event => {
    if (!activeDialog) return;
    if (event.key === 'Escape') {
      consumeEscapeKeyup = true;
      event.preventDefault();
      event.stopPropagation();
      closeDialog();
    } else if (event.key === 'Tab') {
      const focusable = [...activeDialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]')].filter(el => el.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  }, true);
  // Impulse closes its outer quick-view modal on keyup, after our dialog closed.
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && consumeEscapeKeyup) {
      consumeEscapeKeyup = false;
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
  document.addEventListener('close', event => finishClose(event.target), true);
  document.addEventListener('shopify:section:unload', event => {
    if (activeDialog && event.target.contains(activeDialog)) closeDialog();
  });
})();
